module.exports = __webpack_public_path__ + "img/cohort-preview.4e08bac0.png";